



function submenuHoverOpenV2() {


    if( jQuery(".icmb-tpl-n5").length ){

        var itemMenuMain                = ".mainitms-tpl-m7 .mictn-m7>ul>li.subm-m7 .mittl-m7" ;
        var itemMenuMainParent          = ".mainitms-tpl-m7 .subm-m7" ;
        var itemMenuMainParentHover     = ".mainitms-tpl-m7 .subm-m7:hover" ;
        var header                      = ".header-tpl-m7" ;
        var itemMenuMainActived         = "actived-m7" ;
        var headerShowSubmenu           = "smenushow-m7" ;
        var body                        = "body" ;
        var menuShow                    = "showmenu-m7" ;
        var subMenuActived              = ".mainitms-tpl-m7 .misubmnu-m7" ;
        var itemMenu                    = ".mainitms-tpl-m7 .sminner-m7" ;
        var itemMenuButton              = ".mainitms-tpl-m7 .sminner-m7 .smttl-m7" ;
        // var totalItemsSubmenu           = ".mainitms-tpl-m7 .msmin-m7 .smcontt-m7" ;
        var itemMenushow                = "show-m7" ;
        var subSubMenuActived           = ".mainitms-tpl-m7 .sbinitms-m7" ;
        var backdrop                    = ".subackdrop-m7" ;
        var totalSubmenuItems           = ".mainitms-tpl-m7 .sbiinner-m7>ul" ;
        var clpsUnderMenu               = ".contmnu-tpl-m7 .inexpc-m7" ;
        var clpsUnderMenuOpened         = "openclps-m7" ;
        var buttonSubmenuInner          = ".mainitms-tpl-m7 .subm-m7 .js-togglesbitm-m7";
        var buttonSubmenuInnerParent    = ".pnlsi-m7";
        var haveSubmenuInner            = "havesbitm-m7";
        var buttonSubmenuMain           = ".mainitms-tpl-m7 .subm-m7 .sbitm-m7.js-togglesbitm-m7";
        var mainItemMenu                = ".mainmenu-tpl-m7 .menuctn-n5";
        var mobileItemMenushow          = "show-m7" ;
        var backwardButton              = ".mainitms-tpl-m7 .sbtopitms-s1 .btn-t";
        var backwardButtonParent        = ".mainitms-tpl-m7 .sminner-m7";



        //calculate and setting height for submenu when openning
        var heightSubmenuPc = function(){

            var maxHeightCategoryItems = 0;
            var outerHeight = 0;
            var deviceWidth = jQuery(window).width();
            var numberSubmenuItem = 0 ;
            var totalSubmenuOpened = 0 ;
            var sumHeightItemsSubmenu = 0 ;

            jQuery('.mainitms-tpl-m7.miold-m7 .mictn-m7 .misubmnu-m7 .sminner-m7').each(function() {

                numberSubmenuItem += 1

                if (jQuery(this).height() > maxHeightCategoryItems) {
                    maxHeightCategoryItems = jQuery(this).height();
                }
            });

            totalSubmenuOpened    = ( maxHeightCategoryItems * numberSubmenuItem);

            var heightSubmenuMain     = ( jQuery(".smcontt-m7").height() + 100) ;
            var differenceHeightNet       = heightSubmenuMain - totalSubmenuOpened;

            jQuery( totalSubmenuItems ).css('height',(sumHeightItemsSubmenu));
            jQuery( subMenuActived ).css('height',(totalSubmenuOpened + 20));
        }

        //setting height submenu in mobile size
        // var heightSubmenuMob = function(){
        //     jQuery( totalSubmenuItems ).css('height', 'auto' );
        //     jQuery( subMenuActived ).css('height', 'auto' );
        // }



        //baz shodan daste bandi mahsoul dar zirmenu

        jQuery( itemMenuButton ).mouseenter(function() {

            if( jQuery(this).parent(backwardButtonParent).siblings().hasClass(itemMenushow) ){
                jQuery(this).parent(backwardButtonParent).siblings().removeClass(itemMenushow);
                jQuery( this ).parent(backwardButtonParent).addClass(itemMenushow);
            }

            else if (jQuery(window).width() <= 1100) {

                if( jQuery(this).hasClass("js-prvntlnk-m7") ){
                    jQuery( this ).parent(backwardButtonParent).addClass(itemMenushow);
                    jQuery( mainItemMenu ).addClass(mobileItemMenushow);
                }
            }

            else{
                jQuery( this ).parent(backwardButtonParent).addClass(itemMenushow);

            }

            // baraye vaghti keh roye submenuTittle ckick shod dobareh ertefah zir menu jadid ra hesab konad
            if (jQuery(window).width() >= 1100){

                heightSubmenuPc();
            }
        });


        //openning submenu whit mousehover on tittle products in menu
        jQuery( itemMenuMainParent ).mouseenter(function() {


            if (jQuery(window).width() >= 1200){

                setTimeout( function(){

                    if (jQuery('.misubmnu-m7:hover').length != 0) {

                    }

                    else{

                        if( jQuery( this ).hasClass(itemMenuMainActived) ){

                            mouseLeaveMenuItme();
                        }
                    }
                    // } ,100);
                } ,300);


                if( jQuery( itemMenuMainParent ).hasClass(itemMenuMainActived) ){
                    jQuery(backdrop).detach();
                }


                if( !jQuery( this ).hasClass(itemMenuMainActived) ){
                    jQuery(itemMenuMainParent).removeClass(itemMenuMainActived);
                    jQuery( this ).addClass(itemMenuMainActived);
                    jQuery(header).addClass(headerShowSubmenu);

                    jQuery("body").append('<div class="subackdrop-m7"></div>');
                    jQuery(body).addClass(menuShow);
                }



                jQuery( this ).addClass(itemMenuMainActived);
                jQuery(header).addClass(headerShowSubmenu);
                jQuery(body).addClass(menuShow);
                jQuery(header).removeClass(clpsUnderMenuOpened);
                jQuery(clpsUnderMenu).collapse('hide');
                heightSubmenuPc();
            }

            else{
                // heightSubmenuMob();
            }
        });


        jQuery( itemMenuMainParent ).click(function() {

            if (jQuery(window).width() >= 992 && jQuery(window).width() < 1199){



                if( jQuery( itemMenuMainParent ).hasClass(itemMenuMainActived) ){
                    jQuery(backdrop).detach();
                }

                if( jQuery( this ).hasClass(itemMenuMainActived) ){
                    mouseLeaveMenuItme();
                }

                else{

                    var submitm = ".mainitms-tpl-m7.misnd-s1 .mictn-m7 .subm-m7";

                    jQuery("body").append('<div class="subackdrop-m7"></div>');
                    jQuery( submitm ).removeClass( 'actived-m7' )
                    jQuery( this ).addClass(itemMenuMainActived);
                    jQuery(header).addClass(headerShowSubmenu);
                    jQuery(body).addClass(menuShow);
                    // jQuery("html").addClass("pcfix-tpl-m7");
                }

                jQuery(clpsUnderMenu).collapse('hide');
                heightSubmenuPc();
            }

            else{
            }
        });


        jQuery(document).mouseup(function (e){

            if (jQuery(window).width() >= 992 && jQuery(window).width() < 1199){

                var container = jQuery(".header-tpl-m7"); // Give you class or ID

                if (!container.is(e.target) &&            // If the target of the click is not the desired div or section
                    container.has(e.target).length === 0) // ... nor a descendant-child of the container
                {
                    mouseLeaveMenuItme(e);
                }
            }
        });



        //closing submenu whit mouseleave from tittle products in menu

        var mouseLeaveMenuItme = function(){

            jQuery(itemMenuMainParent).removeClass( itemMenuMainActived );
            jQuery(header).removeClass(headerShowSubmenu);
            jQuery(backdrop).detach();
            jQuery(body).removeClass(menuShow);
            // jQuery("html").removeClass("pcfix-tpl-m7");
        }






        jQuery( itemMenuMainParent ).mouseleave(function(){


            if (jQuery(window).width() >= 1200){

                setTimeout( function(){

                    if (jQuery(itemMenuMainParentHover).length != 0) {
                        jQuery( this ).addClass(itemMenuMainActived);
                        jQuery(header).addClass(headerShowSubmenu);
                    }

                    else{
                        mouseLeaveMenuItme();
                        jQuery(subMenuActived).collapse('hide');
                    }

                    // }, 0);
                }, 250);

            }
        });

        //jeloye baz shadan collapse zir menu dar size tablet ra migirad
        jQuery(itemMenu).mouseover(function(e){
            if (jQuery(window).width() >= 992){
                e.preventDefault();
                e.stopPropagation();
            }
        });


        //dar size kamtar az 992px collapse kar mikonad va link kar nemikonad . va dar size bishtar az 992 collapse kar nemikonad va link kar mikonad
        var preventLinkSubmenu = function(){

            var clickItemSelector = '.mainitms-tpl-m7 .subm-m7 .smttl-m7';

            //baraye zirmenu asli
            jQuery(clickItemSelector).click(function() {

                // return jQuery(window).width() >= 1200;
            });

            jQuery(clickItemSelector).click(function() {

                if (jQuery(window).width() < 992){
                    jQuery( this ).siblings(subSubMenuActived).collapse('toggle');
                }
                else{
                    jQuery('.smttl-m7').attr('data-toggle', '');
                }
            });

            //baraye zirmenu zirshakheh
            jQuery(buttonSubmenuInner).click(function() {

                if (jQuery(window).width() < 992 ){
                    if(jQuery(this).parent(buttonSubmenuInnerParent).hasClass(haveSubmenuInner)){
                        return false;
                    }
                }
                else{
                    return true;
                }
            });

            jQuery(buttonSubmenuMain).click(function() {

                if (jQuery(window).width() < 992){
                    jQuery( this ).siblings(".subsbitms-m7").collapse('toggle');
                }
                else{
                    jQuery('.sbitm-m7').attr('data-toggle', '');
                }
            });
        };
        preventLinkSubmenu();


        jQuery(document).on('click', itemMenuMain , function(event) {


            if (jQuery(window).width() >= 1200){
                event.preventDefault();
            }
        });


        if (jQuery(window).width() >= 992){
            jQuery(itemMenuMain).attr("data-toggle","");
        }
        else{
            jQuery(itemMenuMain).attr("data-toggle","collapse");
        }


        function resizedwCollapse(){
            // Haven't resized in 100ms!

            var deviceWidthCollapse = jQuery(window).width();

            if( deviceWidthCollapse >= 992){

                if( jQuery(subMenuActived).hasClass("show") ){
                    jQuery(subMenuActived).collapse('hide');
                }

                jQuery(itemMenuMain).attr("data-toggle","");
            }
            else{
                jQuery(itemMenuMain).attr("data-toggle","collapse");
                mouseLeaveMenuItme();
            }
        }


        var doitCollapse;

        window.onresize = function(){
            clearTimeout(doitCollapse);
            doitCollapse = setTimeout(resizedwCollapse, 300);
        };
    }
};





export {submenuHoverOpenV2}
